import Card from '@/components/ui/Card';

interface MarketingCardProps {
  utmData?: Record<string, string> | null;
}

export default function MarketingCard({ utmData }: MarketingCardProps) {
  if (!utmData || Object.keys(utmData).length === 0) {
    return null;
  }

  return (
    <Card title="Marketing Attribution" padding="md">
      <div className="space-y-2 text-sm">
        {Object.entries(utmData).map(([key, value]) => {
          const displayKey = key.replace(/^utm_/, '');
          return (
            <div key={key} className="flex justify-between">
              <span className="text-stone-500 capitalize">{displayKey}</span>
              <span className="text-stone-700">{value}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
